import axios from 'axios';
// ---------- TYPES ----------
export var AstronautSortOption;
(function (AstronautSortOption) {
    AstronautSortOption["LaunchOrder"] = "launch order";
    AstronautSortOption["Name"] = "name";
    AstronautSortOption["Nation"] = "nation";
    AstronautSortOption["DaysInSpace"] = "days in space";
    AstronautSortOption["Spacewalks"] = "spacewalks";
    AstronautSortOption["DaysSpacewalking"] = "days spacewalking";
    AstronautSortOption["Missions"] = "missions";
})(AstronautSortOption || (AstronautSortOption = {}));
export const astronautSortOptions = [
    AstronautSortOption.LaunchOrder,
    AstronautSortOption.Name,
    AstronautSortOption.Nation,
    AstronautSortOption.DaysInSpace,
    AstronautSortOption.Spacewalks,
    AstronautSortOption.DaysSpacewalking,
    AstronautSortOption.Missions
];
export var AstronautFilter;
(function (AstronautFilter) {
    AstronautFilter["LifeForm"] = "life form";
    AstronautFilter["Gender"] = "gender";
    AstronautFilter["Nation"] = "nation";
    AstronautFilter["Mission"] = "missions";
    AstronautFilter["Craft"] = "craft";
    AstronautFilter["OtherCrafts"] = "otherCrafts";
})(AstronautFilter || (AstronautFilter = {}));
export const DEFAULT_ADB_SORT = AstronautSortOption.LaunchOrder;
export const DEFAULT_ADB_FILTERS = new Map([
    [AstronautFilter.LifeForm, 'human']
]);
// ---------- FUNCTIONS ----------
export const getMinifiedAstronauts = async (config) => {
    const res = await axios.get(`https://supercluster-iadb.s3.us-east-2.amazonaws.com/${config.ADB_APP_FILE}`);
    return res.data;
};
export const parseAdbData = (astronautsRaw, missionsRaw, agencies, nations, spacecrafts, awardTypes) => {
    let lifeFormOptions = [];
    let genderOptions = [];
    let nationOptions = [];
    let missionOptions = [];
    let craftOptions = [];
    let otherCraftOptions = [];
    let missionsInflated = [];
    if (missionsRaw) {
        missionsInflated = missionsRaw.map((m) => {
            const mission = m;
            if (mission && mission.spacecrafts) {
                mission.spacecrafts = mission.spacecrafts.map((c) => spacecrafts.filter((_c) => _c._id === c._id)[0]);
            }
            if (mission && mission.agencies) {
                mission.agencies = mission.agencies.map((a) => agencies.filter((_a) => _a._id === a._id)[0]);
            }
            if (mission && mission.nations) {
                mission.nations = mission.nations.map((n) => nations.filter((_n) => _n._id === n._id)[0]);
            }
            return mission;
        });
    }
    const astronauts = astronautsRaw.map((_astronaut) => {
        const astronaut = _astronaut;
        if (missionsRaw && astronaut.missions) {
            astronaut.missions = astronaut.missions.map((m) => {
                return missionsInflated.filter((_m) => _m._id === m._id)[0];
            });
        }
        if (agencies && astronaut.agencies) {
            astronaut.agencies = astronaut.agencies.map((a) => {
                return agencies.filter((_a) => _a._id === a._id)[0];
            });
        }
        if (nations && astronaut.nations) {
            astronaut.nations = astronaut.nations.map((n) => {
                return nations.filter((_n) => _n._id === n._id)[0];
            });
        }
        if (awardTypes && astronaut.awards) {
            astronaut.awards = astronaut.awards.map((a) => {
                const award = a;
                award.awardType = awardTypes.filter((t) => t._id === a.awardType._id)[0];
                return award;
            });
        }
        if (astronaut.speciesGroup &&
            !lifeFormOptions.includes(astronaut.speciesGroup)) {
            lifeFormOptions.push(astronaut.speciesGroup);
        }
        if (astronaut.gender && !genderOptions.includes(astronaut.gender)) {
            genderOptions.push(astronaut.gender);
        }
        astronaut.nationsNames = [];
        (astronaut?.nations || []).forEach((nation) => {
            if (!nation || !nation.name) {
                return;
            }
            const nationKey = nation.abbreviatedName || nation.name;
            if (nation.name && !astronaut.nationsNames.includes(nationKey)) {
                astronaut.nationsNames.push(nationKey);
            }
            if (nation.name && !nationOptions.includes(nationKey)) {
                nationOptions.push(nationKey);
            }
        });
        if (astronaut.nationsNames.length > 0) {
            astronaut.primaryNation = astronaut.nationsNames[0];
        }
        let totalSpaceDuration = (astronaut.totalMinutesInSpace || 0) * 60 * 1000;
        if (astronaut.lastActiveLaunchDate) {
            const nowTimestamp = Date.parse(new Date().toISOString());
            const dateTimestamp = Date.parse(new Date(astronaut.lastActiveLaunchDate.utc).toISOString());
            totalSpaceDuration += nowTimestamp - dateTimestamp;
        }
        astronaut.sortTimeInSpace = totalSpaceDuration;
        let totalSpacewalkDuration = (astronaut.totalSecondsSpacewalking || 0) * 1000;
        if (astronaut.lastSpacewalkStartTime) {
            const nowTimestamp = Date.parse(new Date().toISOString());
            const dateTimestamp = Date.parse(new Date(astronaut.lastSpacewalkStartTime.utc).toISOString());
            totalSpacewalkDuration += nowTimestamp - dateTimestamp;
        }
        astronaut.sortSpacewalkTime = totalSpacewalkDuration;
        astronaut.missionNames = [];
        astronaut.spacecraftNames = [];
        astronaut.missionCount = (astronaut.missions || []).length;
        (astronaut?.missions || []).forEach((mission) => {
            if (mission && mission.seriesName) {
                astronaut.missionNames.push(mission.seriesName);
                if (!missionOptions.includes(mission.seriesName)) {
                    missionOptions.push(mission.seriesName);
                }
            }
            if (mission && mission.spacecrafts) {
                (mission?.spacecrafts || []).forEach((craft) => {
                    if (!craft || !craft.title) {
                        return;
                    }
                    astronaut.spacecraftNames.push(craft.title);
                    const hasIcons = craft.whiteIcon && craft.blackIcon && craft.filledBlackIcon;
                    if (hasIcons && craft.title && !craftOptions.includes(craft.title)) {
                        craftOptions.push(craft.title);
                    }
                    if (!hasIcons && !otherCraftOptions.includes(craft.title)) {
                        otherCraftOptions.push(craft.title);
                    }
                });
            }
        });
        if (astronaut.lastLaunchDate && astronaut.lastLaunchDate.utc) {
            astronaut.lastLaunchUnix = Date.parse(new Date(astronaut.lastLaunchDate.utc).toISOString());
        }
        else {
            astronaut.lastLaunchUnix = 0;
        }
        return astronaut;
    });
    lifeFormOptions = ['human'].concat(lifeFormOptions
        .sort((a, b) => (a > b ? 1 : -1))
        .filter((n) => n !== 'human'));
    genderOptions = genderOptions
        .sort((a, b) => (a > b ? 1 : -1))
        .filter((n) => n !== 'both');
    missionOptions = missionOptions.sort((a, b) => (a > b ? 1 : -1));
    craftOptions = craftOptions.sort((a, b) => (a > b ? 1 : -1));
    otherCraftOptions = otherCraftOptions.sort((a, b) => (a > b ? 1 : -1));
    nationOptions = ['USA', 'Russia', 'USSR'].concat(nationOptions
        .sort((a, b) => (a > b ? 1 : -1))
        .filter((n) => n !== 'USSR' && n !== 'Russia' && n !== 'USA'));
    const filterOptionsMap = new Map([
        [AstronautFilter.LifeForm, lifeFormOptions],
        [AstronautFilter.Gender, genderOptions],
        [AstronautFilter.Nation, nationOptions],
        [AstronautFilter.Mission, missionOptions],
        [AstronautFilter.Craft, craftOptions],
        [AstronautFilter.OtherCrafts, otherCraftOptions]
    ]);
    return {
        astronauts,
        filterOptionsMap
    };
};
export const filterAstronauts = (astronauts, selectedFilterMap, sort, sortAscending, onlyShowAstronautsInSpace) => {
    const remainingLifeFormOptions = [];
    const remainingGenderOptions = [];
    const remainingNationOptions = [];
    const remainingMissionOptions = [];
    const remainingCraftOptions = [];
    const remainingOtherCraftOptions = [];
    let inSpaceFilterSelectable = false;
    const totalHumanCount = astronauts.filter((astronaut) => {
        if (astronaut.astroNumber === 'FIRST FLIGHT') {
            return false;
        }
        return astronaut.speciesGroup === 'human';
    }).length;
    const totalNonHumanCount = astronauts.filter((astronaut) => {
        if (astronaut.astroNumber === 'FIRST FLIGHT') {
            return false;
        }
        return astronaut.speciesGroup !== 'human';
    }).length;
    const matches = astronauts.filter((astronaut) => {
        if (astronaut.astroNumber === 'FIRST FLIGHT') {
            return false;
        }
        if (onlyShowAstronautsInSpace && !astronaut.inSpace) {
            return false;
        }
        if (selectedFilterMap.get(AstronautFilter.LifeForm) !== undefined &&
            astronaut.speciesGroup !== selectedFilterMap.get(AstronautFilter.LifeForm)) {
            return false;
        }
        if (selectedFilterMap.get(AstronautFilter.Gender) !== undefined &&
            astronaut.gender !== selectedFilterMap.get(AstronautFilter.Gender) &&
            selectedFilterMap.get(AstronautFilter.Gender) !== 'both') {
            return false;
        }
        if (selectedFilterMap.get(AstronautFilter.Nation) !== undefined &&
            !astronaut.nationsNames.includes(selectedFilterMap.get(AstronautFilter.Nation))) {
            return false;
        }
        if (selectedFilterMap.get(AstronautFilter.Mission) !== undefined &&
            !(astronaut.missionNames || []).includes(selectedFilterMap.get(AstronautFilter.Mission))) {
            return false;
        }
        if (selectedFilterMap.get(AstronautFilter.Craft) !== undefined &&
            !(astronaut.spacecraftNames || []).includes(selectedFilterMap.get(AstronautFilter.Craft))) {
            return false;
        }
        if (selectedFilterMap.get(AstronautFilter.OtherCrafts) !== undefined &&
            !(astronaut.spacecraftNames || []).includes(selectedFilterMap.get(AstronautFilter.OtherCrafts))) {
            return false;
        }
        if (astronaut.inSpace) {
            inSpaceFilterSelectable = true;
        }
        if (astronaut.speciesGroup &&
            !remainingLifeFormOptions.includes(astronaut.speciesGroup)) {
            remainingLifeFormOptions.push(astronaut.speciesGroup);
        }
        if (astronaut.gender &&
            !remainingGenderOptions.includes(astronaut.gender)) {
            remainingGenderOptions.push(astronaut.gender);
        }
        (astronaut?.nations || []).forEach((nation) => {
            const nationKey = nation.abbreviatedName || nation.name;
            if (nationKey && !remainingNationOptions.includes(nationKey)) {
                remainingNationOptions.push(nationKey);
            }
        });
        (astronaut?.missions || []).forEach((mission) => {
            if (mission) {
                if (mission.seriesName &&
                    !remainingMissionOptions.includes(mission.seriesName)) {
                    remainingMissionOptions.push(mission.seriesName);
                }
                if (mission.spacecrafts) {
                    (mission?.spacecrafts || []).forEach((craft) => {
                        if (craft.whiteIcon && craft.blackIcon && craft.filledBlackIcon) {
                            if (craft.title && !remainingCraftOptions.includes(craft.title)) {
                                remainingCraftOptions.push(craft.title);
                            }
                        }
                        else if (craft.title &&
                            !remainingOtherCraftOptions.includes(craft.title)) {
                            remainingOtherCraftOptions.push(craft.title);
                        }
                    });
                }
            }
        });
        return true;
    });
    let field;
    switch (sort) {
        case 'launch order':
            field = 'overallNumber';
            break;
        case 'name':
            field = 'lastName';
            break;
        case 'nation':
            field = 'primaryNation';
            break;
        case 'days in space':
            field = 'sortTimeInSpace';
            break;
        case 'days spacewalking':
            field = 'sortSpacewalkTime';
            break;
        case 'spacewalks':
            field = 'spacewalkCount';
            break;
        case 'missions':
            field = 'missionCount';
            break;
        default:
            field = 'overallNumber';
            break;
    }
    let sorted = [];
    if (field === 'lastName') {
        sorted = matches.sort((a, b) => {
            const contentA = a[field] || '';
            const contentB = b[field] || '';
            return contentA.localeCompare(contentB) * (sortAscending ? 1 : -1);
        });
    }
    else {
        sorted = matches.sort((a, b) => {
            const contentA = a[field] || 0;
            const contentB = b[field] || 0;
            if (sortAscending) {
                return contentA > contentB ? 1 : -1;
            }
            return contentA < contentB ? 1 : -1;
        });
    }
    const noFlights = sorted.filter((a) => a.astroNumber === 'N/A');
    sorted = sorted.filter((a) => a.astroNumber !== 'N/A').concat(noFlights);
    const humanResultCount = sorted.filter((a) => a.speciesGroup === 'human').length;
    const nonHumanResultCount = sorted.filter((a) => a.speciesGroup !== 'human').length;
    const remainingFilterOptionsMap = new Map();
    remainingFilterOptionsMap.set(AstronautFilter.LifeForm, remainingLifeFormOptions);
    remainingFilterOptionsMap.set(AstronautFilter.Gender, remainingGenderOptions);
    remainingFilterOptionsMap.set(AstronautFilter.Nation, remainingNationOptions);
    remainingFilterOptionsMap.set(AstronautFilter.Mission, remainingMissionOptions);
    remainingFilterOptionsMap.set(AstronautFilter.Craft, remainingCraftOptions);
    remainingFilterOptionsMap.set(AstronautFilter.OtherCrafts, remainingOtherCraftOptions);
    return {
        totalHumanCount,
        totalNonHumanCount,
        humanResultCount,
        nonHumanResultCount,
        astronauts: sorted,
        remainingFilterOptionsMap,
        inSpaceFilterSelectable
    };
};
export const speciesGroupDisplayName = (group) => {
    const map = {
        human: 'Human',
        insects: 'Insects, Arachnids, + Worms',
        'sea-creatures': 'Fish, Mollusks, + Crustaceans',
        robots: 'Robots + Mannequins',
        mammals: 'Cats, Dogs, + Bats',
        rodents: 'Rodents',
        primates: 'Primates',
        fungus: 'Fungus',
        reptiles: 'Reptiles + Amphibians',
        'micro-creatures': 'Micro-Creatures'
    };
    return map[group];
};
export const deriveAstronautFilterOptionDisplayName = (field, option) => {
    if (field === AstronautFilter.LifeForm) {
        switch (option) {
            case 'All':
                return 'All';
            case 'human':
                return 'human';
            case 'mammals':
                return 'DOGS, CATS, + BATS';
            case 'sea-creatures':
                return 'FISH + SHELLS';
            case 'fungus':
                return 'FUNGUS';
            case 'insects':
                return 'Insects, Arachnids, + Worms';
            case 'micro-creatures':
                return 'Micro-Creatures';
            case 'primates':
                return 'Primates';
            case 'reptiles':
                return 'REPTILES + AMPHIBIANS';
            case 'rodents':
                return 'RODENTS';
            default:
                return option;
        }
    }
    else {
        return option;
    }
};
export const deriveAstronautFilterOptionState = (availableOptions, selectedOption, option) => {
    const selected = selectedOption === option ||
        (selectedOption === undefined && option === 'All');
    const selectable = availableOptions.includes(option) || option === 'All';
    return { selected, selectable };
};
//# sourceMappingURL=adb.js.map